import { useQuery } from "@tanstack/react-query";
import { getSupportedChains } from "./get-tokens-and-chains";

export const useSupportedChains = ({ search }: { search?: string }) => {
  return useQuery({
    queryKey: ["chains", search],
    queryFn: () => getSupportedChains({ search }),
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnWindowFocus: false,
    retry: false, // Disable Tanstack's retry since we handle it in getSupportedChains
    retryOnMount: false,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
  });
};
